<template>
  <b-container fluid
    ><b-row>
      <b-col class="top_bar" />
    </b-row>
    <b-row
      ><b-col><div class="page_title">Course Relationships</div></b-col></b-row
    >
    <b-row class="mb-3"
      ><b-col class="col-4">
        <div class="search_input">
          <span class="fa fa-search search_input-icon" />
          <input
            v-model="searchString"
            type="text"
            class="form-control tsny_input search_input-input"
            :placeholder="'Search Course Relationships'"
          />
        </div> </b-col
      ><b-col>
        <b-button class="tsny_button mr-3" @click="openCreateRelationshipModal"
          >+ Create Relationship</b-button
        >
        <b-button
          class="tsny_button mr-3"
          :disabled="!isRowSelected"
          @click="openUpdateRelationshipModal"
          ><i class="fa fa-edit" /> Edit Relationship</b-button
        >
        <b-button
          class="tsny_button mr-3"
          :disabled="!isRowSelected"
          @click="openDeleteRelationshipModal"
          >- Delete Relationship</b-button
        >
        <b-button
          class="tsny_button"
          :disabled="!isRowSelected"
          @click="viewCourseRelationship"
          >View Relationship</b-button
        >
      </b-col></b-row
    ><b-row>
      <b-col>
        <b-table
          class="tsny_text-mid text-center"
          thead-tr-class="tsny_table-head"
          tbody-tr-class="tsny_table-body"
          borderless
          selectable
          :select-mode="'single'"
          striped
          :items="courseRelationships"
          :fields="fields"
          :filter="searchString"
          :filter-included-fields="filterOn"
          @row-selected="rowSelected"
        >
          <template slot="nextSessionDate" slot-scope="data">
            <span>{{ formatNextSession(data.item) }}</span>
            <i
              class="ml-1 fa fa-info-circle alert-icon"
              v-if="reportDue(data.item._id)"
            />
          </template>
        </b-table>
      </b-col>
    </b-row>
    <create-course-relationship
      :students="studentEmails"
      :tutors="tutorEmails"
    />
    <update-course-relationship
      v-if="selectedCourseRelationship"
      :relationship="selectedCourseRelationship"
      :tutors="tutorEmails"
    />
    <delete-course-relationship
      v-if="selectedCourseRelationship"
      :relationship="selectedCourseRelationship"
    />
  </b-container>
</template>

<script>
import CreateCourseRelationship from "../../components/CourseRelationships/CreateCourseRelationship";
import DeleteCourseRelationship from "../../components/CourseRelationships/DeleteCourseRelationship";
import UpdateCourseRelationship from "../../components/CourseRelationships/UpdateCourseRelationship";
import StoreConstants from "../../store/services/StoreConstants";
import { mapGetters } from "vuex";
import moment from "moment";

export default {
  name: "CourseRelationships",
  components: {
    UpdateCourseRelationship,
    DeleteCourseRelationship,
    CreateCourseRelationship
  },
  data: function() {
    return {
      fields: [
        {
          key: "courseId",
          sortable: true
        },
        {
          key: "tutorEmail",
          sortable: true
        },
        {
          key: "studentEmail",
          sortable: true
        },
        {
          key: "nextSessionDate",
          label: "Next Session",
          sortable: true
        }
      ],
      filterOn: ["courseId", "tutorEmail", "studentEmail"],
      searchString: null,
      selectedCourseRelationship: null
    };
  },
  computed: {
    ...mapGetters({
      reportDue: StoreConstants.GETTERS.IS_SESSION_REPORT_DUE,
      courseRelationships: StoreConstants.GETTERS.COURSES,
      userEmails: StoreConstants.GETTERS.USER_EMAILS
    }),
    studentEmails() {
      return this.userEmails.students;
    },
    tutorEmails() {
      return this.userEmails.tutors;
    },
    isRowSelected: function() {
      return (
        this.selectedCourseRelationship &&
        Object.keys(this.selectedCourseRelationship).length
      );
    }
  },
  methods: {
    openCreateRelationshipModal: function() {
      this.$bvModal.show("createCourseRelationshipModal");
    },
    openUpdateRelationshipModal: function() {
      this.$bvModal.show("updateCourseRelationshipModal");
    },
    openDeleteRelationshipModal: function() {
      this.$bvModal.show("deleteCourseRelationshipModal");
    },
    viewCourseRelationship: function() {
      this.$router.push({
        name: "Course",
        params: {
          id: this.selectedCourseRelationship._id
        }
      });
    },
    rowSelected: function(items) {
      this.selectedCourseRelationship = items[0];
    },
    formatNextSession: function(course) {
      return course.nextSessionDate
        ? moment(course.nextSessionDate).format("MMMM DD, YYYY") +
            (course.nextSessionStartTime && course.nextSessionEndTime
              ? ` from ${moment(course.nextSessionStartTime, "h:mm a").format(
                  "hA"
                )}-${moment(course.nextSessionEndTime, "h:mm a").format("hA")}`
              : " Time TBD")
        : "TBD";
    }
  }
};
</script>

<style scoped></style>
